import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export default function LuxuryConfirmModal({
  open,
  onOpenChange,
  title = "Are you sure?",
  description = "This action cannot be undone.",
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  destructive = false,
  onConfirm,
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent
        data-testid="luxury-confirm-modal"
        className="bg-[#0E0E0E] border border-white/10 rounded-2xl text-white shadow-[0_30px_80px_-30px_rgba(0,0,0,0.8)] backdrop-blur-xl"
      >
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display text-2xl tracking-tight text-white">
            {title}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-white/55 text-sm leading-relaxed">
            {description}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="h-px bg-gradient-to-r from-transparent via-[#D4AF37]/40 to-transparent my-1" />
        <AlertDialogFooter className="gap-2 sm:gap-3">
          <AlertDialogCancel
            data-testid="modal-cancel-btn"
            className="bg-transparent border border-white/15 text-white/75 hover:bg-white/5 hover:text-white rounded-full px-5"
          >
            {cancelLabel}
          </AlertDialogCancel>
          <AlertDialogAction
            data-testid="modal-confirm-btn"
            onClick={onConfirm}
            className={
              destructive
                ? "bg-red-500/90 text-white hover:bg-red-500 rounded-full px-6 font-medium"
                : "bg-[#D4AF37] text-black hover:bg-[#F3CE5A] rounded-full px-6 font-medium"
            }
          >
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
